export default "__VITE_ASSET__7FY1PrtX__";